import { render } from "./CompetitiveMoat.vue?vue&type=template&id=61b4ad22&scoped=true"
import script from "./CompetitiveMoat.vue?vue&type=script&lang=js"
export * from "./CompetitiveMoat.vue?vue&type=script&lang=js"

import "./CompetitiveMoat.vue?vue&type=style&index=0&id=61b4ad22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b4ad22"]])

export default __exports__